import api from '@/services/api'
import { getSearchString } from '@/lib/api'

export const getGoalsFromApi = async (orderBy, sortedBy, perPage, currentPage, filtered) => {
    try {
        const params = {
            with: 'tags',
            orderBy,
            sortedBy,
            per_page: perPage,
            page: currentPage,
        }

        const searchString = getSearchString(filtered)

        if (searchString) {
            params.search = searchString
            params.and = 'yes'
        }

        return api.get('goals/all-with-relationships', { params })
    } catch (e) {
        console.log(e)
    }
}

export const getGoalBookFromApi = async (goalsIDs) => {
    return api
        .post('goals/print-pdf', { ids: goalsIDs }, { responseType: 'arraybuffer' })
        .then((resp) => {
            let file = new Blob([resp.data], {
                type: 'application/pdf',
            })
            let fileURL = URL.createObjectURL(file)
            window.open(fileURL)
        })
        .catch((error) => {
            console.log(error)
        })
}
export const getDownloadTargetsFromApi = async (
    orderBy,
    sortedBy,
    perPage,
    currentPage,
    filtered,
    goalsIds,
    isForUpload,
    isForUploadCreate = false
) => {
    const params = {
        orderBy,
        sortedBy,
        per_page: perPage,
        page: currentPage,
        ids: goalsIds,
        only_owner_goals: isForUpload,
        is_for_upload_create: isForUploadCreate
    }

    const searchString = getSearchString(filtered)

    if (searchString) {
        params.search = searchString
        params.and = 'yes'
    }

    try {
        return await api.get('goals/download', {
            params,
            responseType: 'arraybuffer',
        })
    } catch (e) {
        console.log(e)
    }
}

export const uploadTargetsToApi = async (file, isForUploadCreate = false) => {
    try {
        return await api.post('goals/upload', {
            file,
            isForUploadCreate
        })
    } catch (e) {
        console.log(e)
    }
}

export const getDownloadCheckinsFromApi = async (orderBy, sortedBy, perPage, currentPage, filtered, goalsIds) => {
    const params = {
        orderBy,
        sortedBy,
        per_page: perPage,
        page: currentPage,
        ids: goalsIds,
    }

    const searchString = getSearchString(filtered)

    if (searchString) {
        params.search = searchString
        params.and = 'yes'
    }

    try {
        return await api.get('goals/dowload-template-checkin', {
            params,
            responseType: 'arraybuffer',
        })
    } catch (e) {
        console.log(e)
    }
}

export const uploadCheckinsToApi = async (file) => {
    try {
        return await api.post('goals/upload-checkin', {
            file,
        })
    } catch (e) {
        console.log(e)
    }
}
